export default __webpack_public_path__ + "static/media/Assigned.95229deb.svg";